var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.questions),function(question,questionIndex){return _c('div',{key:question.id,class:{
      'quiz__card': true,
      'is-active': questionIndex === _vm.activeQuestion,
      'is-completed': questionIndex < _vm.activeQuestion,
    },style:({ zIndex: questionIndex })},[_c('quiz-question',{attrs:{"question":question,"is-active":questionIndex === _vm.activeQuestion},on:{"answer-correct":(answer) => _vm.onCorrectAnswer(question, answer),"answer-wrong":(answer) => _vm.onWrongAnswer(question, answer)}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }